import { render, staticRenderFns } from "./global_notes_detailed.vue?vue&type=template&id=07d7e60c"
import script from "./global_notes_detailed.vue?vue&type=script&lang=js"
export * from "./global_notes_detailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports